import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { currentOpenChatIDSelector } from '../../../selectors';
import { markMessagesAsReadWithTimeout } from '../../../services/markMessagesAsRead';
import { TMessage } from '../../../types/messages';

export const useMessagesRead = (): {
  markMessagesAsRead: () => void;
  unreadMessagesCount: number;
  setRefInMessagesMap: (ref: HTMLDivElement | null, message: TMessage, messageId: string) => void;
  getFirstUnreadMessage: () => HTMLDivElement | null;
} => {
  // const [unreadMessagesCount, setUnreadMessagesCount] = React.useState<number>(0);
  // Пока счетчик не актуален, т.к. мы читаем все сообщения в чате сразу
  const unreadMessagesCount = 0;

  const chatId = useSelector(currentOpenChatIDSelector) as string;

  const dispatch = useDispatch();

  const unreadMessagesMap: Map<string, { element: HTMLDivElement }> = React.useMemo(() => new Map(), []);

  const readMessage = React.useCallback(
    (chatId: string, messageIds: string[]) => markMessagesAsReadWithTimeout({ chatId, messageIds })(dispatch),
    [dispatch],
  );

  // TODO: мы отправляем на бек id чата и читаются сразу все сообщения в нем
  // TODO: пока нет смысла отслеживать сообщения в зоне видимости
  const markMessagesAsRead = React.useCallback(() => {
    // const messageIds: string[] = [];
    // let unreadCounter = 0;
    //
    // if (scrollRef.current && unreadMessagesMap.size) {
    //   const containerPosition = scrollRef.current.top;
    //   const containerHeight = scrollRef.current.height;
    //   for (const [messageId, data] of unreadMessagesMap.entries()) {
    //     const diff = data.element.getBoundingClientRect().top - containerPosition;
    //
    //     if (diff >= 0 && diff <= containerHeight) {
    //       messageIds.push(messageId);
    //       unreadMessagesMap.delete(messageId);
    //     } else if (diff >= 0) {
    //       unreadCounter++;
    //     }
    //   }
    // }

    if (unreadMessagesMap.size) {
      const messageIds: string[] = [...unreadMessagesMap.keys()];

      readMessage(chatId, messageIds);
      unreadMessagesMap.clear();
    }
  }, [chatId, readMessage, unreadMessagesMap]);

  const setRefInMessagesMap = React.useCallback(
    (ref: HTMLDivElement | null, message: TMessage, messageId: string) => {
      if (!ref || message.isOutcoming || message.isRead) {
        return;
      }

      unreadMessagesMap.set(messageId, {
        element: ref,
      });
    },
    [unreadMessagesMap],
  );

  // Получаем первое непрочитанное сообщение
  const getFirstUnreadMessage = React.useCallback(() => {
    const firstUnreadMessage = unreadMessagesMap.values().next().value;

    return firstUnreadMessage ? firstUnreadMessage.element : null;
  }, [unreadMessagesMap]);

  return { markMessagesAsRead, unreadMessagesCount, setRefInMessagesMap, getFirstUnreadMessage };
};
